import Divider from "@mui/material/Divider";
import FormControl from "@mui/material/FormControl";
import Grid from "@mui/material/Grid";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import React, { useEffect, useState } from "react";
import { connect, useStore } from "react-redux";
import { Link, Navigate } from "react-router-dom";
import { getMachinePoolsofUser } from "../../../../actions/machines";
import {
  ShareNotification,
  getAttachments,
  getNotification,
} from "../../../../actions/notification";
import { ApplyStyle as _s } from "../../../../utils/ApplyStyle";
import { Tooltip } from "@mui/material";

import DnsIcon from "@mui/icons-material/Dns";
import PersonIcon from "@mui/icons-material/Person";
import ScheduleIcon from "@mui/icons-material/Schedule";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import {
  DeleteNotification,
  UpdateNotification,
} from "../../../../actions/notification";
import DeletePopUp from "../../../../components/DeletePopup";
import IconText from "../../../../components/IconText";
import { Theme247 } from "../../../../styles/Theme247";
import { notificationStates } from "../../../../types";

import { ReactComponent as ReportedIcon } from "../../../../assets/reportedSvg.svg";

import { makeStyles } from "tss-react/mui";
import { setItem } from "../../../../utils/DataProtection";
import { GetProgressStatus } from "../../../../shared-functions/notification";
import { getNotificationOwner } from "../../../../utils/notificationOwner";
function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default connect(
  ({ data, notification, isadmin, userProfile, profile, i18n }) => ({
    data,
    notification,
    isadmin,
    userProfile,
    profile,
    i18n,
  }),
  {
    getNotification,
    getAttachments,
    getMachinePoolsofUser,
    UpdateNotification,
    DeleteNotification,
    ShareNotification,
  }
)((props) => {
  const [notificationState, setNotificationState] = useState(false);
  const [stateSnack, setstateSnack] = React.useState({
    openSnack: false,
    vertical: "top",
    horizontal: "center",
    text: "",
  });
  const { vertical, horizontal, openSnack, text } = stateSnack;
  ////console.log( notification?.notification?.type)
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setstateSnack({ openSnack: false });
  };
  var notification = props.notification;
  const i18n = useStore().getState().i18n;
  const store = useStore().getState();
  const useStyles = makeStyles()((theme) => ({
    notificationDetails: {
      padding: "28px 24px",
    },
    notificationStateSelect: {
      width: "100%",
    },
    notificationDetailsContainer: {
      display: "flex",
      flexDirection: "row",
      paddingLeft: 24,
    },
    optionsButtonContainer: {
      marginTop: -12,
      marginLeft: 24,
    },
    sectionButtonFooter: {
      ...Theme247.sectionButtonFooter,
    },
    heading: {
      fontSize: Theme247.typography.pxToRem(15),
      fontWeight: Theme247.typography.fontWeightRegular,
    },
  }));
  const { classes } = useStyles();
  const handleNotificationStateChange = (event) => {
    setNotificationState(event.target.value);
    const nodeid = notification?.notification.nodeid;
    const status = event.target.value;
    const previousStatus = Number(notification?.notification?.status);
    var payload = {};
    const onlyStatusUpdate = true;
    //open > in progress: set status and progressstarted TS
    if (previousStatus == 0 && status == 1) {
      const progressstarted = Date.now();
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
      };
    }
    //open > closed: set status, set progressstarted and closed to same TS
    else if (previousStatus == 0 && status == 2) {
      const progressstarted = Date.now();
      const closed = moment(Date.now());
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        closed,
      };
      let timeDifference = closed.diff(notification?.notification.created);

      // if time longer than 48h, show time range as days
      if (timeDifference < 172800000) {
        timeDifference = closed.diff(
          notification?.notification.created,
          "hours"
        );
      } else {
        timeDifference = closed.diff(
          notification?.notification.created,
          "days"
        );
      }
      /* setstateSnack({ openSnack: true, vertical: 'top', horizontal: 'center', text: 'Time for this notification is ' + timeDifference }); */
    }

    //in progress > closed: set status and closed TS
    else if (previousStatus == 1 && status == 2) {
      const progressstarted = Date.now();
      const closed = moment(Date.now());
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        closed,
      };
      let timeDifference = closed.diff(notification?.notification.created);

      // if time longer than 48h, show time range as days
      if (timeDifference < 172800000) {
        timeDifference =
          closed.diff(notification?.notification.created, "hours") + " Hrs.";
      } else {
        timeDifference =
          closed.diff(notification?.notification.created, "days") + " Days.";
      }
      setstateSnack({
        openSnack: true,
        vertical: "top",
        horizontal: "center",
        text: "Time for this notification:" + timeDifference,
      });
    }
    //in progress > open: set status, set progrssstarted to 0
    else if (previousStatus == 1 && status == 0) {
      const progressstarted = 0;
      const closed = Date.now();
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
      };
    }

    //closed > in progress: set status, set closed to 0
    else if (previousStatus == 2 && status == 1) {
      const closed = 0;
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        closed,
      };
    }
    //closed > open: set status, set closed to 0, set progressstarted to 0
    else if (previousStatus == 2 && status == 0) {
      const progressstarted = 0;
      const closed = 0;
      payload = {
        nodeid,
        status,
        previousStatus,
        onlyStatusUpdate,
        progressstarted,
        closed,
      };
    }
    payload.title = notification?.notification?.title;
    payload.type = notification?.notification?.type;
    payload.description = notification?.notification?.description;
    payload.equipmentnodeid = getNotificationOwner(
      notification?.notification
    ).owner?.nodeid;
    payload.closed = payload?.closed?.valueOf();
    props.UpdateNotification(payload, "UPDATENOTIFICATIONSTATUS");
    props.getNotification(
      { nodeid: notification?.notification?.nodeid },
      "GETSINGLENOTIFICATION"
    );
  };
  const [isShare, setIsShare] = useState(false);
  const [email, setEmail] = useState();
  const handleShareOpen = () => {
    setIsShare(true);
  };

  const handleShareClose = () => {
    setIsShare(false);
  };

  const handleShareInputChange = (event) => {
    setEmail(event.target.value);
  };

  var userProfile = props.userProfile;

  const handleShareSubmit = () => {
    props.ShareNotification(
      {
        nodeid: notification?.notification?.nodeid,
        receiver: email,
        name: userProfile?.user?.givenname + " " + userProfile?.user?.surname,
      },
      "ShareNotification"
    );
    setEmail("");
    setIsShare(false);
    setstateSnack({
      openSnack: true,
      vertical: "top",
      horizontal: "center",
      text: "Email Sent Successfully!",
    });
  };
  const [anchorEl, setanchorEl] = useState();
  const [open, setopen] = useState(false);
  const handleClick = (event) => {
    setanchorEl(event.currentTarget);
    setopen(true);
  };
  const handleCloseDelete = () => {
    setanchorEl(null);
    setopen(false);
  };
  var state_payload = {};
  const [openDialogDelete, setopenDialogDelete] = useState();

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };
  const [navigate, setNavigate] = useState(false);
  const handleDelete = () => {
    const nodeid = props.notification.notification.nodeid;
    props.DeleteNotification({ nodeid });
    setNavigate(true);
    setopenDialogDelete(false);
  };

  useEffect(() => {
    // set notification state for select
    setNotificationState(notification.notification?.status);
    setItem(
      "chatroomnodeid",
      notification?.notification?.haschatroom
        ? notification?.notification?.haschatroom?.[0]?.chatroom?.nodeid
        : ""
    );
  }, [notification]);

  let hasAuther = notification?.notification?.hasauthor;

  const getUpdatedText = (notification) => {
    if (notificationState === 0) {
      return (
        <span>
          <span >{i18n.opened} </span>

          {GetProgressStatus(notification.notification)}

        </span>
      );
    } else if (notificationState === 1) {
      return (
        <span>
          <span >{i18n.in_progress} </span>
          {i18n.protocol_title_pretext +
            " " +
            moment(notification.notification.progressstarted).format(
              "DD.MM.YY"
            ) +
            ", " +
            moment(notification.notification.progressstarted).format("HH:mm") +
            " Uhr "}
        </span>
      );
    } else if (notificationState === 2) {
      return (
        <span>
          <span >{"Geschlossen am "} </span>
          {moment(notification.notification?.closed).format("DD.MM.YY") +
            ", " +
            moment(notification.notification?.closed).format("HH:mm") +
            " Uhr "}
        </span>
      );
    }
  };

  return (
    <>
      {navigate ? <Navigate push to="/notifications-dashboard" /> : null}
      <Grid
        container
        alignItems="center"
        className={classes.notificationDetails}
      >
        <Grid xs={3}>
          <FormControl
            variant="outlined"
            className={classes.notificationStateSelect}
          >
            <InputLabel id="select-notification-state-label">
              {i18n.problem_solution_status}
            </InputLabel>
            <Select
              labelId="select-notification-state-label"
              id="select-notification-state"
              value={notificationState}
              onChange={handleNotificationStateChange}
              label={i18n.problem_solution_status}
            >
              {notificationStates.map((state) => {
                return (
                  <MenuItem key={state.value} value={state.code}>
                    {state.label}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>

        <Grid xs={9} className={classes.notificationDetailsContainer}>
          <ul
            className={_s(
              Theme247.iconTextList
            )} /*  style={{ display: notification?.notification?.type == 6 ? 'none' : 'block' }} */
          >
            <li>
              <IconText
                icon={<ReportedIcon />}
                text={
                  <span style={{ cursor: "pointer" }}>
                    <Tooltip
                      title={
                        i18n.reported +
                        ": " +
                        moment(notification?.notification?.created).format(
                          "DD.MM.YY"
                        ) +
                        ", " +
                        moment(notification?.notification?.created).format(
                          "hh:mm"
                        ) +
                        " Uhr durch " +
                        (hasAuther
                          ? notification?.notification?.hasauthor[0]?.user
                              ?.givenname +
                            " " +
                            notification?.notification?.hasauthor[0]?.user
                              ?.surname
                          : "")
                      }
                    >
                      {i18n.reported + ": "}

                      <span
                        style={{
                          borderBottomStyle: "dotted",
                          borderBottomWidth: "1px",
                        }}
                      >
                        {moment(notification?.notification?.created).format(
                          "DD.MM.YY"
                        ) +
                          ", " +
                          moment(notification?.notification?.created).format(
                            "HH:mm"
                          ) +
                          " Uhr "}
                      </span>
                    </Tooltip>
                  </span>
                }
              />
            </li>
            <li>
              <Grid
                xs={9}
                className={classes.notificationDetailsContainer}
                style={{ margin: "9px 0px 0px 0px", padding: 0 }}
              >
                <Grid
                  xs={12}
                  className={classes.notificationDetailsContainer}
                  style={{ paddingLeft: 0, marginTop: -10 }}
                >
                  <IconText
                    icon={
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3687_10215"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="17"
                        >
                          <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3687_10215)">
                          <path
                            d="M9.75016 11.1834C9.87239 11.3056 10.0224 11.3667 10.2002 11.3667C10.3779 11.3667 10.5335 11.3 10.6668 11.1667C10.7891 11.0445 10.8502 10.8889 10.8502 10.7C10.8502 10.5112 10.7891 10.3556 10.6668 10.2334L8.66683 8.23337V5.81671C8.66683 5.62782 8.60305 5.47226 8.4755 5.35004C8.3475 5.22782 8.18905 5.16671 8.00016 5.16671C7.81127 5.16671 7.65305 5.23049 7.5255 5.35804C7.3975 5.48604 7.3335 5.64449 7.3335 5.83337V8.48337C7.3335 8.57226 7.35016 8.65826 7.3835 8.74137C7.41683 8.82493 7.46683 8.90004 7.5335 8.96671L9.75016 11.1834ZM8.00016 15.1667C7.07794 15.1667 6.21127 14.9916 5.40016 14.6414C4.58905 14.2916 3.8835 13.8167 3.2835 13.2167C2.6835 12.6167 2.20861 11.9112 1.85883 11.1C1.50861 10.2889 1.3335 9.42226 1.3335 8.50004C1.3335 7.57782 1.50861 6.71115 1.85883 5.90004C2.20861 5.08893 2.6835 4.38337 3.2835 3.78337C3.8835 3.18337 4.58905 2.70826 5.40016 2.35804C6.21127 2.00826 7.07794 1.83337 8.00016 1.83337C8.92239 1.83337 9.78905 2.00826 10.6002 2.35804C11.4113 2.70826 12.1168 3.18337 12.7168 3.78337C13.3168 4.38337 13.7917 5.08893 14.1415 5.90004C14.4917 6.71115 14.6668 7.57782 14.6668 8.50004C14.6668 9.42226 14.4917 10.2889 14.1415 11.1C13.7917 11.9112 13.3168 12.6167 12.7168 13.2167C12.1168 13.8167 11.4113 14.2916 10.6002 14.6414C9.78905 14.9916 8.92239 15.1667 8.00016 15.1667ZM8.00016 13.8334C9.47794 13.8334 10.7364 13.314 11.7755 12.2754C12.8142 11.2363 13.3335 9.97782 13.3335 8.50004C13.3335 7.02226 12.8142 5.76382 11.7755 4.72471C10.7364 3.68604 9.47794 3.16671 8.00016 3.16671C6.52239 3.16671 5.26416 3.68604 4.2255 4.72471C3.18638 5.76382 2.66683 7.02226 2.66683 8.50004C2.66683 9.97782 3.18638 11.2363 4.2255 12.2754C5.26416 13.314 6.52239 13.8334 8.00016 13.8334Z"
                            fill="black"
                            fill-opacity="0.5"
                          />
                        </g>
                      </svg>
                    }
                    text={getUpdatedText(notification)}
                  />

                  <IconText
                    style={{ marginLeft: "25px" }}
                    icon={
                      <svg
                        width="16"
                        height="17"
                        viewBox="0 0 16 17"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <mask
                          id="mask0_3687_13131"
                          style={{ maskType: "alpha" }}
                          maskUnits="userSpaceOnUse"
                          x="0"
                          y="0"
                          width="16"
                          height="17"
                        >
                          <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_3687_13131)">
                          <path
                            d="M7.99984 8.49996C7.2665 8.49996 6.63873 8.23885 6.1165 7.71663C5.59428 7.1944 5.33317 6.56663 5.33317 5.83329C5.33317 5.09996 5.59428 4.47218 6.1165 3.94996C6.63873 3.42774 7.2665 3.16663 7.99984 3.16663C8.73317 3.16663 9.36095 3.42774 9.88317 3.94996C10.4054 4.47218 10.6665 5.09996 10.6665 5.83329C10.6665 6.56663 10.4054 7.1944 9.88317 7.71663C9.36095 8.23885 8.73317 8.49996 7.99984 8.49996ZM11.9998 13.8333H3.99984C3.63317 13.8333 3.31928 13.7027 3.05817 13.4416C2.79706 13.1805 2.6665 12.8666 2.6665 12.5V11.9666C2.6665 11.5888 2.76373 11.2416 2.95817 10.925C3.15262 10.6083 3.41095 10.3666 3.73317 10.2C4.42206 9.85551 5.12206 9.59718 5.83317 9.42496C6.54428 9.25274 7.2665 9.16663 7.99984 9.16663C8.73317 9.16663 9.45539 9.25274 10.1665 9.42496C10.8776 9.59718 11.5776 9.85551 12.2665 10.2C12.5887 10.3666 12.8471 10.6083 13.0415 10.925C13.2359 11.2416 13.3332 11.5888 13.3332 11.9666V12.5C13.3332 12.8666 13.2026 13.1805 12.9415 13.4416C12.6804 13.7027 12.3665 13.8333 11.9998 13.8333ZM3.99984 12.5H11.9998V11.9666C11.9998 11.8444 11.9693 11.7333 11.9082 11.6333C11.8471 11.5333 11.7665 11.4555 11.6665 11.4C11.0665 11.1 10.4609 10.875 9.84984 10.725C9.23873 10.575 8.62206 10.5 7.99984 10.5C7.37761 10.5 6.76095 10.575 6.14984 10.725C5.53873 10.875 4.93317 11.1 4.33317 11.4C4.23317 11.4555 4.15261 11.5333 4.0915 11.6333C4.03039 11.7333 3.99984 11.8444 3.99984 11.9666V12.5ZM7.99984 7.16663C8.3665 7.16663 8.68039 7.03607 8.9415 6.77496C9.20261 6.51385 9.33317 6.19996 9.33317 5.83329C9.33317 5.46663 9.20261 5.15274 8.9415 4.89163C8.68039 4.63051 8.3665 4.49996 7.99984 4.49996C7.63317 4.49996 7.31928 4.63051 7.05817 4.89163C6.79706 5.15274 6.6665 5.46663 6.6665 5.83329C6.6665 6.19996 6.79706 6.51385 7.05817 6.77496C7.31928 7.03607 7.63317 7.16663 7.99984 7.16663Z"
                            fill="black"
                            fill-opacity="0.5"
                          />
                        </g>
                      </svg>
                    }
                    text={"Gemeldet von "}
                    right={
                      <span style={{ color: "rgba(56, 116, 141, 1)" }}>
                        {hasAuther
                          ? notification?.notification?.hasauthor[0]?.user
                              ?.givenname +
                            " " +
                            notification?.notification?.hasauthor[0]?.user
                              ?.surname
                          : ""}
                      </span>
                    }
                  />
                </Grid>
              </Grid>
            </li>
          </ul>

          {/* <Divider orientation="vertical" className={_s(Theme247.detailsDivider)} /> */}

          {/* <li><IconText icon={<DnsIcon />} text={i18n.machine + ': '} right={
              <Link to={'/machine-overview?nodeid=' + encodeURIComponent(notification?.notification?.isnotificationof && notification?.notification?.isnotificationof[0]?.equipment?.nodeid)}>{isnotificationof}</Link>
            } />
            </li> */}
          {/*  <li>
          <IconText icon={<IosShareRoundedIcon />} text={"Share"} /> 
         <IconText icon={<CategoryIcon />} text={isequipmentof} />
        </li> */}
          {/* <li>
              <IconText icon={<FiShare style={{ marginLeft: 375, fontSize: 30, marginTop: -42, position: 'absolute', cursor: "pointer" }} onClick={handleShareOpen} />} text="" />
            </li> */}

          {/* canUserPerformAction(props.profile?.features?.notification,"delete")&&
            <div className={classes.optionsButtonContainer} >
              <IconButton className={classes.moreFilterButton}
                aria-label="more"
                aria-controls="long-menu"
                aria-haspopup="true"
                onClick={handleClick}>
                <MoreVertIcon />
              </IconButton>
              <Menu
                id="long-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleCloseDelete}
                getContentAnchorEl={null}
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                transformOrigin={{ vertical: "top", horizontal: "right" }}
                keepMounted
              >
                <MenuItem>
                  <Link style={{ paddingRight: 10 }} onClick={() => { setopenDialogDelete(true) }}>{i18n.delete} {i18n.notification_singular}</Link>
                  <Delete fontSize="small" />
                </MenuItem>
              </Menu>
            </div> */}
        </Grid>
      </Grid>
      <DeletePopUp
        open={openDialogDelete}
        handleClose={handleDialogDelete}
        handleDelete={handleDelete}
        topic={i18n?.notification_singular}
      ></DeletePopUp>

      {/* <Dialog
      sx={{ backdropFilter: "blur(4px)" }}
      TransitionComponent={Zoom}
        open={isShare}
        onClose={handleShareClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className='share-notification-dialog'

      >
        <DialogTitle id="alert-dialog-title">{"Share Notification"}</DialogTitle>
        <DialogContent id="alert-dialog-description" >
          Please Write An Email Address
        </DialogContent>
        <DialogActions style={{ display : "flex", flexDirection:"column", padding: "0px 22px 22px 22px" }}>
        
            <TextField variant="outlined" label="Email" type='text' sx={{ width : "100% "}} onChange={handleShareInputChange} value={email} />
            <Button className='bxShadow' sx={{ width : "100% ",marginTop:"10px"}} variant="outlined" startIcon={<Send />} onClick={handleShareSubmit}>
              Send
            </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        anchorOrigin={{ vertical, horizontal }}
        open={openSnack}
        onClose={handleClose}
        key={vertical + horizontal}
        autoHideDuration={6000}

      >
        <Alert onClose={handleClose} severity="success">
          {text}
        </Alert>
      </Snackbar> */}
    </>
  );
});
